"use client";

import React from 'react';
import { MatrixText } from '@/components/ui/matrix-text';

interface MatrixDisplayProps {
  className?: string;
}

export function MatrixDisplay({ className = '' }: MatrixDisplayProps) {
  return (
    <div className={`text-xs ${className}`}>
      <MatrixText 
        phrases={[
          "ARTIFICIAL INTELLIGENCE",
          "GENERATIVE ART",
          "NEW MEDIA ART",
          // "COMPUTATIONAL DESIGN",
          // "DIGITAL AESTHETICS"
        ]} 
        className="tracking-wider text-black"
        interval={2500}
        glitchProbability={0.05}
      />
    </div>
  );
}